import React from "react"

function ThumbsUp({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0007 16.0166H8.29315V26.7419H11.0007V16.0166Z"
        stroke="#003E4C"
        strokeWidth="1.00126"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7726 16.0164H14.2097C14.301 16.0164 14.3858 15.9725 14.4385 15.899C14.8055 15.385 16.261 13.3485 16.5562 12.9353C16.59 12.8873 16.6084 12.8304 16.6084 12.7717C16.6084 12.3626 16.6084 10.6623 16.6084 9.78905C16.6084 9.08948 17.0257 8.45809 17.669 8.18419C17.7372 8.16343 17.8042 8.13854 17.8717 8.11719C18.5707 7.90081 19.3308 8.02947 19.9195 8.46343C20.5082 8.89739 20.8562 9.5851 20.8562 10.3167C20.8585 11.9375 20.8585 14.948 20.8585 15.7917C20.8585 15.9233 20.9498 16.0371 21.0779 16.0662C21.8403 16.2381 24.4257 16.8209 26.2322 17.2288C26.7224 17.339 27.1481 17.6402 27.4161 18.0653C27.684 18.4903 27.7712 19.0043 27.6591 19.4946C27.1997 21.5026 26.4752 24.6714 26.0531 26.517C25.8569 27.3766 25.0921 27.9861 24.2099 27.9861C22.1201 27.9861 18.55 27.9861 18.1225 27.9861C18.0941 27.9861 18.0662 27.9819 18.0395 27.9736C17.5522 27.8236 12.81 26.3658 12.81 26.3658"
        stroke="#003E4C"
        strokeWidth="1.00126"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default ThumbsUp
